<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div  class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>
                  My wishlist
                </h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard </router-link>\ Wishlist
                </div>
              </div>

            </div>
          </div>
          <div class="card-body ">
            <div class="table-responsive ">
              <table class="table">
                <thead>
                <tr class="px-3">
                  <th>Image</th>
                  <th>Book detail</th>
                  <th>Added date</th>
                  <th>Status</th>
                  <th class="pr-3 text-center">Actions</th>
                </tr>
                </thead>
                <tbody >
                  <tr v-show="wishlists.length > 0" v-for="(wishlist, index)  of wishlists" :key="index">
                    <td>
                      <img v-if="wishlist.image_path && wishlist.image_path.thumb" :src="wishlist.book_image_path.thumb"
                           width="100"
                           alt="">
                      <img v-else src="https://img.icons8.com/officel/80/000000/book.png" alt="" width="80">
                    </td>
                    <td>
                      <div class="text-secondary">
                        <span class="font-weight-black">Title:</span> {{ wishlist.book_title }}
                      </div>
                      <div class="text-secondary">
                        <span class="font-weight-black">Author:</span> {{ wishlist.book_author }}
                      </div>
                      <div class="text-secondary">
                        <span class="font-weight-black">Publisher:</span> {{ wishlist.book_publisher }}
                      </div>
                      <div class="text-secondary">
                        <span class="font-weight-black">Publication:</span> {{ wishlist.book_publication }}
                      </div>
                      <div class="text-secondary" v-if="wishlist.book_edition">
                        <span class="font-weight-black">Edition:</span> {{ wishlist.book_edition }}
                      </div>
                    </td>
                    <td>
                    <span class="font-weight-medium">
                      {{wishlist.added_on}}
                    </span>
                    </td>
                    <td>
                      <span class="badge badge-success" v-if="wishlist.book_in_stock">Available</span>
                      <span class="badge badge-danger" v-else>Not available</span>
                    </td>
                    <td class="pr-0 text-center">
                      <template>
                        <b-dropdown
                            size="sm"
                            variant="link"
                            toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                            no-caret
                            right
                            no-flip
                        >
                          <template v-slot:button-content>
                            <i class="ki ki-bold-more-hor"></i>
                          </template>
                          <div class="navi navi-hover min-w-md-250px">
                            <b-dropdown-text tag="div" class="navi-item" >
                              <a class="navi-link" @click.prevent="deleteWishlist(wishlist.id)">
                                <span class="navi-icon">
                                  <i class="fas fa-trash red--text"></i>
                                </span>
                                <span class="navi-text">Delete</span>
                              </a>
                            </b-dropdown-text>
                          </div>
                        </b-dropdown>
                      </template>
                    </td>
                  </tr>
                  <tr v-if="wishlists.length==0">
                    <td class="text-center" colspan="5">
                      <strong>No items added.</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--      <div class="card-body p-0 mt-2">
        <div
            class="wizard wizard-2"
            id="kt_wizard_v2"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
        >
      <div class="wizard-body">
        <div class="row">
          <div class="col-12">
              <template v-if="!isLoading && wishlists.length>0">
                <div class="row">
                  <div class="col-lg-6" v-for="(wish, index) of wishlists" :key="index">
                    <div class="card mb-8">
                      <div class="card-body">
                        <div class="p-6">
                          &lt;!&ndash;                    <h2 class="text-dark mb-8">Buying Product &amp; Support</h2>&ndash;&gt;
                          &lt;!&ndash;begin::Accordion&ndash;&gt;
                          <div class="accordion accordion-light accordion-light-borderless accordion-svg-toggle"
                               id="accordionExample7">
                            &lt;!&ndash;begin::Item&ndash;&gt;
                            <div class="card">
                              &lt;!&ndash;begin::Header&ndash;&gt;
                              <div class="card-header" id="headingOne7">
                                <div class="card-title" data-toggle="collapse" data-target="#collapseOne7"
                                     aria-expanded="true" role="button">
                                  <div class="card-label text-dark">
                                    <span>{{ wish.book_title }}</span>
                                    <span class="float-right btn btn-success btn-sm" @click="deleteWishlist(wish.id)">
                                     <i class="fas fa-heart text-danger" ></i> In wishlist
                                    </span>
                                  </div>
                                </div>
                              </div>
                              &lt;!&ndash;end::Header&ndash;&gt;
                              &lt;!&ndash;begin::Body&ndash;&gt;
                              <div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7"
                                   data-parent="#accordionExample7">
                                <div class="row">
                                  <div class="col-8">
                                    <p v-if="wish.book_author"><b>Author</b> : {{ wish.book_author }}</p>
                                    <p v-if="wish.book_publisher"><b>Publisher</b> : {{ wish.book_publisher }}</p>
                                    <p v-if="wish.book_publication"><b>Publication</b> : {{ wish.book_publication }}</p>
                                    <p v-if="wish.book_edition"><b>Edition</b> : {{ wish.book_edition }}</p>
                                    <p v-if="wish.book_year_of_publication"><b>Publish year</b> : {{ wish.book_year_of_publication }}</p>
                                    <p v-if="wish.book_no_of_pages"><b>No. of pages</b> : {{ wish.book_no_of_pages }}</p>
                                    <span class="badge badge-success" v-if="wish.book_in_stock">Stock Available</span><span class="badge badge-error" v-else>Not available</span>
                                  </div>
                                  <div class="col-4 text-right">
                                    <img v-if="wish.image_path && wish.image_path.thumb" :src="book.book_image_path.thumb"
                                         width="100"
                                         alt="">
                                    <img v-else src="https://img.icons8.com/officel/80/000000/book.png" alt="" width="80">
                                  </div>
                                </div>
                              </div>
                              &lt;!&ndash;end::Body&ndash;&gt;
                            </div>
                            &lt;!&ndash;end::Item&ndash;&gt;
                            &lt;!&ndash;end::Item&ndash;&gt;
                            &lt;!&ndash;begin::Item&ndash;&gt;
                            &lt;!&ndash;end::Item&ndash;&gt;
                          </div>
                          &lt;!&ndash;end::Accordion&ndash;&gt;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>-->

  </v-app>
</template>

<script>
import WishlistService from "@/core/services/library/wishlist/WishlistService";

const wishlistService = new WishlistService();
export default {
  name: "Index",
  computed: {
    user() {
      return this.$store.getters.currentUser;
    },
  }, data() {
    return {
      wishlists: [],
      isLoading: true,
    }
  },
  mounted() {
    this.getUserWishlist()
  },
  methods: {
    getUserWishlist() {
      this.isLoading = true
      wishlistService.userWishlist(this.user.id).then(response => {
        this.wishlists = response.data.wishlist;
      }).finally(() => {
        this.isLoading = false
      })
    },
    deleteWishlist(id) {
      this.$confirm({
        message: `Are you sure you want to remove this book from your wishlist?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            wishlistService.delete(id).then(response => {
              this.$snotify.success("Wishlist deleted successfully")
              this.getUserWishlist();
            })
          }
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
